<template>
  <div class="sidebar-error__container">
    <p class="text-h-3 handle-section__title">{{ title }}</p>
    <p class="text-p-3 sidebar-error__description">{{ description }}</p>
    <Button size="xs" :on-click="() => $emit('refresh-request')">
      Recarregar
    </Button>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator';
import { Button } from '@warrenbrasil/nebraska-web';

@Component({
  components: {
    Button
  }
})
export default class SidebarError extends Vue {
  @Prop({ type: String, required: true })
  private title!: string;

  @Prop({ type: String, required: true })
  private description!: string;
}
</script>

<style lang="less" scoped>
.sidebar-error__container {
  /deep/ button {
    color: @text-primary;
    background-color: @background-tertiary;
  }
}
.sidebar-error__description {
  margin-bottom: @size-spacing-x400;
  display: flex;
  align-items: left;
  color: @text-secondary;
  border-top: 1px solid @divider-primary;
  padding-top: @size-spacing-x350;
}

.handle-section__title {
  margin-bottom: @size-spacing-x300;
}
</style>
